/* Adaptina (Sensa) — comportements de la page clonée, sans aucun script du concurrent */
(function () {
  var C = window.ADA_CFG || {};
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- carrousels (piste défilante + flèches) ---------- */
  function step(track) {
    var it = track.querySelector('.gem-slider-item');
    if (!it) return track.clientWidth;
    var mr = parseFloat(getComputedStyle(it).marginRight) || 0;
    return it.getBoundingClientRect().width + mr;
  }
  function initCarousel(wrap) {
    var track = wrap.querySelector('.gem-slider-wrapper');
    if (!track || track.dataset.ada) return;
    track.dataset.ada = '1';
    track.classList.add('ada-track');
    var arrows = $$('button[class*="gp-carousel-arrow-"]', wrap).filter(function (b) { return !track.contains(b); });
    var isMain = track.className.indexOf('gp-carousel-slider-gp-carousel-') > -1;
    var isThumbs = track.className.indexOf('gp-carousel-slider-gp-gallery-') > -1;
    if (isMain || isThumbs) return; /* galerie : gérée plus bas */
    if (track.className.indexOf('gp-carousel-slider-g6V_gZ9Gj_') > -1 && arrows.length >= 2) {
      /* carrousel sans boucle : flèche « précédent » cachée au début, « suivant » à la fin */
      var upd = function () { var max = track.scrollWidth - track.clientWidth; arrows[0].style.visibility = track.scrollLeft > 2 ? 'visible' : 'hidden'; arrows[arrows.length - 1].style.visibility = track.scrollLeft < max - 2 ? 'visible' : 'hidden'; };
      track.addEventListener('scroll', function () { clearTimeout(track._t); track._t = setTimeout(upd, 60); }, { passive: true });
      setTimeout(upd, 50); window.addEventListener('resize', upd);
    }
    if (arrows.length >= 2) {
      arrows[0].addEventListener('click', function () {
        var max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft <= 2) track.scrollTo({ left: max, behavior: 'smooth' });
        else track.scrollBy({ left: -step(track), behavior: 'smooth' });
      });
      arrows[arrows.length - 1].addEventListener('click', function () {
        var max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= max - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step(track), behavior: 'smooth' });
      });
    }
  }

  /* ---------- galerie produit : grande image + vignettes ---------- */
  function initGallery() {
    var main = document.querySelector('.gp-carousel-slider-gp-carousel-g8Ex3-knMa');
    var thumbs = document.querySelector('.gp-carousel-slider-gp-gallery-g8Ex3-knMa');
    if (!main || !thumbs) return;
    main.classList.add('ada-track', 'ada-main');
    thumbs.classList.add('ada-track', 'ada-thumbs');
    var slides = $$(':scope > .gem-slider-item', main), th = $$(':scope > .gem-slider-item', thumbs);
    var cur = 0;
    function setActive(i, scrollMain) {
      cur = (i + slides.length) % slides.length;
      th.forEach(function (t, k) { t.classList.toggle('active', k === cur); t.classList.toggle('gem-slider-item-active', k === cur); });
      if (scrollMain) main.scrollTo({ left: cur * main.clientWidth, behavior: 'smooth' });
      var t = th[cur];
      if (t) {
        var l = t.offsetLeft - thumbs.offsetLeft, w = t.offsetWidth;
        if (l < thumbs.scrollLeft || l + w > thumbs.scrollLeft + thumbs.clientWidth) thumbs.scrollTo({ left: l - (thumbs.clientWidth - w) / 2, behavior: 'smooth' });
      }
    }
    th.forEach(function (t, k) { t.addEventListener('click', function () { setActive(k, true); }); });
    var to;
    main.addEventListener('scroll', function () {
      clearTimeout(to);
      to = setTimeout(function () { var i = Math.round(main.scrollLeft / main.clientWidth); if (i !== cur) setActive(i, false); }, 80);
    }, { passive: true });
    [main, thumbs].forEach(function (tr) {
      var wrap = tr.closest('.gp-carousel-wrapper');
      var arrows = $$('button[class*="gp-carousel-arrow-"]', wrap).filter(function (b) { return !tr.contains(b); });
      if (arrows.length >= 2) {
        arrows[0].addEventListener('click', function () { setActive(cur - 1, true); });
        arrows[arrows.length - 1].addEventListener('click', function () { setActive(cur + 1, true); });
      }
    });
    setActive(0, false);
  }

  /* ---------- accordéon FAQ ---------- */
  function initAccordion() {
    $$('gp-accordion').forEach(function (acc) {
      $$('.gp-accordion-item', acc).forEach(function (item) {
        var head = item.querySelector('.gp-accordion-item_header'), body = item.querySelector('.gp-accordion-item_body');
        var icon = item.querySelector('.gp-accordion-item_icon');
        if (!head || !body) return;
        head.addEventListener('click', function () {
          var open = body.getAttribute('data-show') === 'true';
          body.setAttribute('data-show', open ? 'false' : 'true');
          body.style.gridTemplateRows = open ? '0fr' : '1fr';
          if (icon) icon.style.transform = open ? '' : 'rotate(45deg)';
        });
      });
    });
  }

  /* ---------- bandeau presse défilant ---------- */
  function initMarquee() {
    $$('.rfm-marquee').forEach(function (m) {
      var w = m.getBoundingClientRect().width;
      m.style.setProperty('--duration', (Math.max(w, 300) / 100) + 's');
    });
  }

  /* ---------- « Leggi di più » des témoignages ---------- */
  function initReadMore() {
    $$('.testimonial-wrapper').forEach(function (w) {
      var t = w.querySelector('.testimonial-text'), b = w.querySelector('.read-more-btn');
      if (!t || !b) return;
      function refresh() {
        var lh = parseFloat(getComputedStyle(t).lineHeight) || 25;
        var c = t.cloneNode(true);
        c.classList.remove('testimonial-collapsed');
        c.setAttribute('style', 'position:absolute!important;left:-9999px!important;visibility:hidden!important;height:auto!important;max-height:none!important;-webkit-line-clamp:unset!important;display:block!important;width:' + t.clientWidth + 'px!important');
        t.parentNode.appendChild(c);
        var full = c.scrollHeight; c.remove();
        w.classList.toggle('has-overflow', full > lh * 3 + 1);
      }
      b.addEventListener('click', function () {
        var col = t.classList.toggle('testimonial-collapsed');
        b.textContent = col ? 'Leggi di più' : 'Leggi meno';
      });
      refresh();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
      window.addEventListener('resize', refresh);
    });
  }

  /* ---------- compte à rebours (cycle 02:17:59 mémorisé) ---------- */
  function initTimer() {
    var TOTAL = (2 * 3600 + 17 * 60 + 59) * 1000, K = 'ada_offer_end';
    function end(now) {
      var e = 0;
      try { e = parseInt(localStorage.getItem(K) || '0', 10); } catch (x) {}
      if (!e || e <= now || e - now > TOTAL + 5000) { e = now + TOTAL; try { localStorage.setItem(K, e); } catch (x) {} }
      return e;
    }
    function p(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = Date.now(), left = Math.max(0, Math.round((end(now) - now) / 1000));
      var h = Math.floor(left / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      $$('.hly-countdown').forEach(function (el) { el.textContent = p(h) + ' : ' + p(m) + ' : ' + p(s); });
      $$('.ada-bar-timer').forEach(function (el) { el.textContent = p(h) + ':' + p(m) + ':' + p(s); });
      $$('[data-elys-timer="hours"]').forEach(function (el) { el.textContent = p(h); });
      $$('[data-elys-timer="minutes"]').forEach(function (el) { el.textContent = p(m); });
      $$('[data-elys-timer="seconds"]').forEach(function (el) { el.textContent = p(s); });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- date de livraison (aujourd'hui + 5 jours) ---------- */
  function initDelivery() {
    var d = new Date(); d.setDate(d.getDate() + 5);
    var g = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
    var mo = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
    var txt = g[d.getDay()] + ' ' + d.getDate() + ' ' + mo[d.getMonth()];
    $$('#delivery-date, .delivery-date, [data-ada-delivery]').forEach(function (el) { el.textContent = txt; });
  }

  /* ---------- offre (paliers) + ajout au panier rapide ---------- */
  var tier = 2;
  function initOffer() {
    $$('.kaching-bundles__bar').forEach(function (bar) {
      bar.addEventListener('click', function (e) {
        tier = parseInt(bar.getAttribute('data-ada-tier'), 10) || 1;
        $$('.kaching-bundles__bar').forEach(function (b) { b.classList.toggle('kaching-bundles__bar--selected', b === bar); var i = b.querySelector('input'); if (i) i.checked = b === bar; });
      });
    });
    var m = /[?&]pack=(\d)/.exec(location.search);
    if (m) { var b = document.querySelector('.kaching-bundles__bar[data-ada-tier="' + m[1] + '"]'); if (b) b.click(); }
  }
  function busy(btn, on) {
    if (!btn) return;
    btn.setAttribute('data-state', on ? 'loading' : 'idle');
    btn.style.pointerEvents = on ? 'none' : '';
    btn.style.opacity = on ? '.7' : '';
  }
  var cartCache = null;
  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { cartCache = c; return c; }).catch(function () { return null; });
  }
  function addToCart(btn) {
    var items = [], code;
    if (tier === 2) {
      items.push({ id: C.variant, quantity: 2 });
      code = C.code2;
    } else {
      items.push({ id: C.variant, quantity: 1 });
      code = undefined;
    }
    busy(btn, true);
    (cartCache ? Promise.resolve(cartCache) : refreshCart()).then(function (cart) {
      cart = cart || {};
      if (tier === 2) {
        var have = {};
        (cart.items || []).forEach(function (i) { have[i.variant_id] = 1; });
        (C.gifts || []).forEach(function (g) { if (!have[g]) items.push({ id: g, quantity: 1 }); });
      }
    }).catch(function () {}).then(function () {
      var p = window.zosAjoutRapide ? window.zosAjoutRapide(items, code) : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }).then(function () { location.href = '/cart'; });
      return p;
    }).then(function () { busy(btn, false); setTimeout(refreshCart, 400); }, function () { busy(btn, false); location.href = '/cart'; });
  }
  function initAtc() {
    if (document.querySelector('.ada-kaching')) {
      refreshCart();
      document.addEventListener('cart:updated', refreshCart);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCart(); });
      setInterval(function () { if (document.querySelector('cart-drawer.active')) refreshCart(); }, 4000);
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ada-atc], .add-to-cart-manualy button, .btn-custom-add');
      if (!btn || !document.querySelector('.ada-kaching')) return;
      e.preventDefault(); e.stopPropagation();
      addToCart(btn);
    }, true);
  }

  /* ---------- LP : flèches externes .smo-prev / .smo-next du carrousel d'avis ---------- */
  function initSmo() {
    var pv = document.querySelector('.smo-prev'), nx = document.querySelector('.smo-next');
    var root = document.querySelector('.gWabzkw_-o');
    var tr = root && (root.querySelector('.gem-slider-wrapper') || (root.closest('.gp-carousel-wrapper') || root).querySelector('.gem-slider-wrapper'));
    if (!tr) { var w = document.querySelector('.gp-carousel-slider-gWabzkw_-o'); tr = w; }
    if (!tr || (!pv && !nx)) return;
    tr.classList.add('ada-track');
    function upd() {
      var max = tr.scrollWidth - tr.clientWidth;
      if (pv) pv.style.visibility = tr.scrollLeft > 2 ? 'visible' : 'hidden';
      if (nx) { var on = tr.scrollLeft < max - 2; var ic = nx.querySelector('svg, i, img') || nx; ic.style.opacity = on ? '1' : '0.45'; nx.style.pointerEvents = on ? 'auto' : 'none'; }
    }
    if (pv) { pv.style.cursor = 'pointer'; pv.addEventListener('click', function () { tr.scrollBy({ left: -step(tr), behavior: 'smooth' }); }); }
    if (nx) { nx.style.cursor = 'pointer'; nx.addEventListener('click', function () { tr.scrollBy({ left: step(tr), behavior: 'smooth' }); }); }
    tr.addEventListener('scroll', function () { clearTimeout(tr._t); tr._t = setTimeout(upd, 60); }, { passive: true });
    upd(); window.addEventListener('resize', upd);
  }

  function init() {
    $$('.gp-carousel-wrapper').forEach(initCarousel);
    initGallery(); initSmo(); initAccordion(); initMarquee(); initReadMore(); initTimer(); initDelivery(); initOffer(); initAtc();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
